"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var ProductOrder_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductOrder = exports.PARTNER_TRACKING_ID = exports.ShipTarget = void 0;
const events_1 = require("../events");
const typeorm_1 = require("typeorm");
const account_1 = require("./account");
const job_1 = require("./job");
const product_order_item_1 = require("./product-order-item");
const carrier_1 = require("./carrier");
const wallbox_install_priority_for_job_1 = require("./wallbox-install-priority-for-job");
const comment_1 = require("./comment");
const contact_1 = require("./contact");
var ShipTarget;
(function (ShipTarget) {
    ShipTarget["PARTNER"] = "partner";
    ShipTarget["CUSTOMER"] = "customer";
})(ShipTarget = exports.ShipTarget || (exports.ShipTarget = {}));
exports.PARTNER_TRACKING_ID = 'partner-confirmation-received-products';
let ProductOrder = ProductOrder_1 = class ProductOrder {
};
ProductOrder.EVENTS = (0, events_1.makeEventsForClass)(ProductOrder_1);
__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)({
        type: 'bigint',
    }),
    __metadata("design:type", String)
], ProductOrder.prototype, "id", void 0);
__decorate([
    (0, typeorm_1.Column)({
        nullable: true,
    }),
    __metadata("design:type", String)
], ProductOrder.prototype, "trackingID", void 0);
__decorate([
    (0, typeorm_1.Column)({
        nullable: true,
        type: 'enum',
        enum: ShipTarget,
    }),
    __metadata("design:type", String)
], ProductOrder.prototype, "shipTo", void 0);
__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    __metadata("design:type", Date)
], ProductOrder.prototype, "dateExpected", void 0);
__decorate([
    (0, typeorm_1.Index)(),
    (0, typeorm_1.ManyToOne)(() => job_1.Job),
    (0, typeorm_1.JoinColumn)(),
    __metadata("design:type", job_1.Job)
], ProductOrder.prototype, "job", void 0);
__decorate([
    (0, typeorm_1.Index)(),
    (0, typeorm_1.ManyToOne)(() => account_1.Account, {
        nullable: true,
        onDelete: 'SET NULL',
        onUpdate: 'CASCADE',
    }),
    (0, typeorm_1.JoinColumn)(),
    __metadata("design:type", account_1.Account)
], ProductOrder.prototype, "supplier", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => carrier_1.Carrier),
    __metadata("design:type", carrier_1.Carrier)
], ProductOrder.prototype, "carrier", void 0);
__decorate([
    (0, typeorm_1.Index)(),
    (0, typeorm_1.Column)('bigint', {
        name: 'carrier_id',
        nullable: true,
    }),
    __metadata("design:type", Number)
], ProductOrder.prototype, "carrierId", void 0);
__decorate([
    (0, typeorm_1.CreateDateColumn)(),
    __metadata("design:type", Date)
], ProductOrder.prototype, "createdAt", void 0);
__decorate([
    (0, typeorm_1.UpdateDateColumn)(),
    __metadata("design:type", Date)
], ProductOrder.prototype, "updatedAt", void 0);
__decorate([
    (0, typeorm_1.OneToMany)(() => product_order_item_1.ProductOrderItem, (item) => item.productOrder, {
        cascade: true,
    }),
    __metadata("design:type", Array)
], ProductOrder.prototype, "items", void 0);
__decorate([
    (0, typeorm_1.OneToOne)(() => wallbox_install_priority_for_job_1.WallboxInstallPriorityForJob, (jobWallboxInstallPriority) => jobWallboxInstallPriority.job),
    (0, typeorm_1.JoinColumn)(),
    __metadata("design:type", wallbox_install_priority_for_job_1.WallboxInstallPriorityForJob)
], ProductOrder.prototype, "jobWallboxInstallPriority", void 0);
__decorate([
    (0, typeorm_1.ManyToMany)(() => comment_1.Comment, (comment) => comment.productOrders),
    (0, typeorm_1.JoinTable)({ name: 'product_order_comments' }),
    __metadata("design:type", Array)
], ProductOrder.prototype, "comments", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => contact_1.Contact, (contact) => contact.productOrders, {
        nullable: true,
    }),
    __metadata("design:type", contact_1.Contact)
], ProductOrder.prototype, "createdByContact", void 0);
ProductOrder = ProductOrder_1 = __decorate([
    (0, typeorm_1.Entity)(),
    (0, typeorm_1.Check)('gid_product_order_check_constraint(tracking_id, carrier_id)')
], ProductOrder);
exports.ProductOrder = ProductOrder;
//# sourceMappingURL=product-order.js.map